var _path, _path2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 390 390",
    width: 390,
    height: 390,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35,25 Q35,15 45,15 H275 L355,95 V365 Q355,375 345,375 H45 Q35,375 35,365 Z",
    fill: "#D04923"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M275,15 L355,95 H275 Z",
    fill: "#E8936A"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 195,
    y: 285,
    fontFamily: "Arial,Helvetica,sans-serif",
    fontSize: 90,
    fontWeight: "bold",
    fill: "#ffffff",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "ppt")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.617bd3f0318f58f18de4d49df2de01be.svg";
export { ForwardRef as ReactComponent };